import api from "../api/axiosConfig";

const categoryService = {
  getCategories: () => api.get("/categories"),
  createCategory: (data) => api.post("/createCategory", data),
  updateCategory: (id, data) => api.put(`/updateCategory/${id}`, data),
  deleteCategory: (id) => api.delete(`/deleteCategory/${id}`),
};

export default categoryService;